import React, { ReactNode, useEffect } from 'react';
import { Button, FormLabel, Grid, Paper } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import * as yup from 'yup';
import styles from './Login.module.scss';
import { TextField } from 'formik-material-ui';
import http from '@nal/helpers/http';
import AuthHelper from '@nal/helpers/authHelper';
import { map, takeUntil } from 'rxjs/operators';
import actions from '@nal/components/Auth/store/actions';
import { AlertControlType, NalAlert } from '@nal/components/NalAlert/NalAlert';
import { interval, Subject } from 'rxjs';
import _ from 'lodash';
import * as H from 'history';

declare var window: Window;

import { useHistory, useLocation } from 'react-router-dom';
import Footer from 'app/components/Common/Footer/Footer';

type LoginPropType = {
    children?: ReactNode;
};

type Values = {
    username: string;
    password: string;
};

const loginWithGoogle = (back_url: string, history: H.History) => {
    const backUrl = window.location.protocol + '//' + window.location.host + '/' + _.trimStart(back_url, '/');

    const url = `${_.trimEnd(process.env.REACT_APP_BACKEND_WEB, '/')}/oauth/google?redirect_url=${encodeURIComponent(
        backUrl
    )}`;

    // direct site
    if (window.self === window.top) {
        return window.location.href = url;
    }

    const hasParams = _.includes(backUrl, '?');

    const popupUrl = `${_.trimEnd(process.env.REACT_APP_BACKEND_WEB, '/')}/oauth/google?redirect_url=${encodeURIComponent(
        _.trimEnd(backUrl, '/') + (hasParams ? '&' : '?') + 'isPopup=1'
    )}`;

    const newWindow: Window | null = window.open(popupUrl, 'sso-popup', 'height=600,width=450');

    const unsubscribeInterval = new Subject<any>();

    const destroyInterval = () => {
        unsubscribeInterval.next();
        unsubscribeInterval.complete();
    }

    interval(1000)
        .pipe(
            takeUntil(unsubscribeInterval),
        ).subscribe({
            next: (count: number) => {
                if (count >= 200 || !newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
                    destroyInterval();
                    history.push(backUrl);
                }
            }
        });
};

export const Login: React.FC<LoginPropType> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const search = location.search.substring(1);
    const searchParams = new URLSearchParams(search);
    const back_url = searchParams.get('back_url');

    const alertControl$: Subject<AlertControlType> = new Subject();


    const validator = yup.object().shape({
        username: yup
            .string()
            .required('メールは、必ず指定してください。')
            .email('メールの形式は、正しく指定してください。'),
        password: yup.string().required('パスワードは、必ず指定してください。'),
    });

    const handleSubmit = (value: Values, setSubmitting: (s: boolean) => void) => {
        http.post(`/auth/login`, value)
            .pipe(map((response: any) => AuthHelper.checkExpirity(_.get(response, 'data.access_token', ''))))
            .subscribe({
                next: (result: any) => {
                    dispatch({
                        type: actions.LOGIN_SUCCESS,
                        payload: _.assign(result, { back_url }),
                        history: history,
                    });
                },
                error: (error) => {
                    alertControl$.next({
                        open: true,
                        data: {
                            message: 'エラーが発生しました。',
                            type: 'error',
                            duration: 3000,
                        },
                    });
                    setSubmitting(false);
                },
            });
    };

    return (
        <Grid container component="main" className={styles.LoginPage}>
            <Grid item xs={false} sm={2} md={9} className={styles.Image} />
            <Grid item xs={12} sm={10} md={3} component={Paper} elevation={6} square>
                <Formik
                    initialValues={{
                        username: '',
                        password: '',
                    }}
                    validationSchema={validator}
                    onSubmit={(values: Values, { setSubmitting }: FormikHelpers<Values>) => {
                        handleSubmit(values, setSubmitting);
                    }}
                    render={({ isSubmitting, isValid, dirty }) => (
                        <Form className={styles.Form}>
                            <FormLabel>
                                <h1>Login</h1>
                            </FormLabel>

                        {/* <Field
                                component={TextField}
                                fullWidth={true}
                                name="username"
                                id="username"
                                label="メール"
                                type="text"
                                autoComplete="off"
                                variant="outlined"
                            />

                            <Field
                                component={TextField}
                                fullWidth={true}
                                name="password"
                                id="password"
                                label="パスワード"
                                type="password"
                                autoComplete="off"
                                variant="outlined"
                            />

                            <div className={styles.Action}>
                                <Button variant="contained" type="submit" disabled={isSubmitting || !isValid || !dirty}>
                                    ログイン
                                </Button>
                            </div> */}

                            <button
                                className={`${styles.GoogleLoginButton}`}
                                type="button"
                                onClick={() => loginWithGoogle(back_url || '', history)}
                            >
                                <div>
                                    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                                        <g fill="#000" fillRule="evenodd">
                                            <path
                                                d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
                                                fill="#EA4335"
                                            ></path>
                                            <path
                                                d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"
                                                fill="#4285F4"
                                            ></path>
                                            <path
                                                d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
                                                fill="#FBBC05"
                                            ></path>
                                            <path
                                                d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z"
                                                fill="#34A853"
                                            ></path>
                                            <path fill="none" d="M0 0h18v18H0z"></path>
                                        </g>
                                    </svg>
                                </div>
                                <span>Sign in with Google</span>
                            </button>
                        </Form>
                    )}
                />
                <Footer/>
            </Grid>
            <NalAlert control={alertControl$}></NalAlert>
        </Grid>
    );
};

export default Login;
